import PropTypes from 'prop-types';

import styled from '@emotion/styled';

const Root = styled.ul`
  position: absolute;
  left: 0;
  z-index: 1;

  width: 100%;
  max-height: 230;
  margin-top: -25;
  padding: 0;

  background: ${props => props.theme.palette.backgrounds.white};
  list-style: none;
  overflow-y: scroll;
  box-shadow: '0px 1px 5px 0px rgba(0,0,0,0.2)', '0px 2px 2px 0px rgba(0,0,0,0.14)',
    '0px 3px 1px -2px rgba(0,0,0,0.12)';
`;

// The container of all options for an AutoComplete component
const AutoCompleteOptions = ({ children }) => <Root>{children}</Root>;

AutoCompleteOptions.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AutoCompleteOptions;
